import { getRequest } from "../../api/ui/common/SearchInput.js";
/* eslint-disable react-hooks/exhaustive-deps */
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";


import { useEffect, useState } from "react";
import { useSelector } from "react-redux";




export default function SearchInput({
  url,
  value,
  setValue,
  label,
  defualtValue,
}) {
  const [inputValue, setInputValue] = useState('');
  const [inputChanged, setinputChanged] = useState(false);
  const [options, setOptions] = useState([]);
  const { token } = useSelector((state) => state.user);
  useEffect(() => {
    getRequest(url, inputValue, token)
      .then((res) => {
        const { data } = res;
      
        setOptions(data?.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
        }
      });
    if (inputValue !== "") {
      setinputChanged(true)
    }
  }, [url, inputValue]);
  console.log(inputValue , 'inputValue')
  return (
    <div>
   {/*    {options[0]?.fname} */}
      <Autocomplete
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        inputValue={!inputChanged && defualtValue ? defualtValue : inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        getOptionLabel={(option) => `${option.fname} ${option.lname}`}
        id="controllable-states-demo"
        options={options}
        renderInput={(params) => <TextField {...params} label={label} />}
      />
    </div>
  );
}
